<template>
  <div id="app">
    <SlideSidebar />

    <LoadingGlobal />

    <CookieWarning />

    <router-view></router-view>
    
    <!-- Portal target para modais e componentes flutuantes -->
    <portal-target name="body"></portal-target>
  </div>
</template>

<script>
  import { setPreviousUrl } from '@/utils/redirector'
  import { mapGetters } from 'vuex'
  import LoadingGlobal from '@/components/layout/LoadingGlobal'
  import CookieWarning from '@/components/layout/CookieWarning'
  import SlideSidebar from '@/components/layout/sidebars/SlideSidebar'


  export default {
    name: 'app',

    components: {
      SlideSidebar,
      CookieWarning,
      LoadingGlobal,
    },

    mounted () {
      setTimeout(() => {
        const el = document.getElementById('global-loading')
        el.classList.add('loaded')
        setTimeout(() => el.parentNode.removeChild(el), 1600)
        window.fbq('init', '2927179654078512')
        window.fbq('track', 'PageView')
      }, 500)

      if (this.isLogged) {
        window.dataLayer = window.dataLayer || []

        window.dataLayer.push({
          event: 'login',
          userId: this.user.id
        })

        window.dataLayer.push({ userId: this.user.id })
      }   
    },

    metaInfo: {
      title: 'CyberClass | Conquiste o poder do digital',
    },

    computed: {
      ...mapGetters('user', ['isLogged', 'user']),
    },

    watch: {
      '$route' () {
        setPreviousUrl(this.$route.path)
      }
    }
}
</script>